import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { createTheme, ThemeProvider } from '@mui/material';
import ExamplePage from './views/ExamplePage/WebhwpExample'
import RunPage from './views/ExamplePage/RunExample'
import NotFound from './views/ErrorPage/NotFoundPage'

const theme = createTheme({
  typography: {
    fontFamily: "Pretendard"
  },
});

function App() {
  return (
    <div id="wrap">
      <ThemeProvider theme={theme}>
        <Router>
          <Routes>
            <Route path="webhwp-example" element={<ExamplePage />} />
            <Route path="run-example" element={<RunPage />} />

            <Route path="/:lang">
              <Route path="webhwp-example" element={<ExamplePage />} />
              <Route path="run-example" element={<RunPage />} />
              <Route path="" element={<NotFound />} />
              <Route path="*" element={<NotFound />} />
            </Route>

            <Route path="/" element={<Navigate replace to="/webhwp-example" />} />
            <Route path="/*" element={<NotFound />} />
          </Routes>
        </Router>
      </ThemeProvider>
    </div>
  );
}

export default App;
